
import React from 'react';
import { useTranslation } from 'react-i18next';
import { priceunit } from '../client-config';
import { DISCOUNT_STYLES } from '../../lib/constants';
import { IDiscountDisplayProps } from '../../lib/types';
import { formatPrice } from '../../utils/format-price';

export const DiscountDisplay: React.FC<IDiscountDisplayProps> = ({
  amount,
  label,
  couponCode,
  className = 'price-info',
}) => {
  const { t } = useTranslation();
  const numericAmount = Number(amount);
  const isValidAmount = !isNaN(numericAmount) && numericAmount > 0;

  if (!isValidAmount) {
    return null;
  }

  const displayLabel = couponCode 
    ? `${t(label)} (${couponCode})`
    : t(label);

  return (
    <div className={className}>
      <h6>{displayLabel} :</h6>
      <h5 style={DISCOUNT_STYLES.AMOUNT}>
        {priceunit} {formatPrice(numericAmount)}
      </h5>
    </div>
  );
};
